export class FlareFileTextEditorFeatures {
  'image-insertion'(version: number) {
    return version > 1;
  }
}
